@if (policy?.generalizedProductType !== GenericProductType.Other) {
  <div class="flex policy" [formGroup]="changeRequestForm">
    <div>
      @for (policydata of description; track policydata; let i = $index) {
        <div class="row">
          <div class="flex self-center pad-bottom-20" [ngClass]="{ lastPolicy: isLastPolicy }">
            @if (policy?.generalizedProductType === GenericProductType.Auto) {
              <div class="self-center pad-right-30">
                <input
                  class="checkbox"
                  type="checkbox"
                  [formControlName]="policy?.policyNumber"
                  [attr.id]="'checkbox-auto-' + policy?.policyNumber + i"
                  [value]="policy?.policyNumber"
                  (change)="changed(policydata)"
                  data-cy="requestChangePolicyRiskCheckbox"
                />
                <label
                  class="checkbox-label"
                  [attr.for]="'checkbox-auto-' + policy?.policyNumber + i"
                  [attr.aria-label]="
                    policy?.policyTypeDisplayName + ' Policy: ' + policydata | titleCase
                  "
                  data-cy="requestChangePolicyAutoCheckbox"
                ></label>
              </div>
            }
            @if (policy?.generalizedProductType !== GenericProductType.Auto) {
              <div class="self-center pad-right-30">
                <input
                  class="checkbox"
                  type="checkbox"
                  [formControlName]="policy?.policyNumber"
                  [attr.id]="'checkbox-other-' + policy?.policyNumber"
                  [value]="policy?.policyNumber"
                  (change)="changed(policy.riskDescriptionList[0])"
                />
                <label
                  class="checkbox-label"
                  [attr.for]="'checkbox-other-' + policy?.policyNumber"
                  [attr.aria-label]="
                    policy?.policyTypeDisplayName + ' Policy: ' + policydata | titleCase
                  "
                  data-cy="requestChangePolicyNonAutoCheckbox"
                ></label>
              </div>
            }
            <div class="self-center pad-right-30 none md-block">
              <h2 aria-hidden="true" class="policyIcon" [ngClass]="policy?.iconType"></h2>
            </div>
            <div class="self-center">
              <span class="policy-heading">{{ policydata }}</span>
              <span>Policy {{ policy | prettyPolicyNum }}<br /></span>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
